import { render } from "./SimpleFold.vue?vue&type=template&id=6435f2ef"
import script from "./SimpleFold.vue?vue&type=script&lang=js"
export * from "./SimpleFold.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__